export default __webpack_public_path__ + "static/media/1929.54736a44.png";